<template>
  <b-nav-item
    v-if="!linkMode"
    right
    :title="$t('F.A.Q.')"
    @click="showInput"
  >
    <feather-icon
      class="text-body"
      icon="HelpCircleIcon"
      size="21"
    />
  </b-nav-item>
  <b-link
    v-else
    class="nav-link"
    :title="$t('F.A.Q.')"
    @click="showInput"
  >{{ $t('F.A.Q.') }}</b-link>
</template>

<script>
import {
  BNavItem, BLink,
} from 'bootstrap-vue'

import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BNavItem,
    BLink,
  },
  props: {
    linkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  methods: {
    async showInput() {
      const askQuestion = async () => {
        const result = await this.$swal({
          title: this.$t('F.A.Q.'),
          html: `<p>${this.$t('Please ask a question:')}</p>`,
          input: 'text',
          inputPlaceholder: this.$t('Write something...'),
          icon: 'question',
          width: '90%',
          showCancelButton: true,
          confirmButtonText: this.$t('Continue'),
          cancelButtonText: this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
          inputValidator: value => {
            if (!value) {
              return this.$t('You need to write something!')
            }
            return null
          },
        })

        if (result.isConfirmed) {
          // Loading message
          await this.$swal({
            title: this.$t('Please wait'),
            text: this.$t('We are generating your answer...'),
            allowOutsideClick: false,
            didOpen: async () => {
              this.$swal.showLoading()

              try {
                console.log('here!')
                const response = await useJwt.axiosIns.post('ai/faq', { prompt: result.value })
                const answer = response.data

                // Show AI response
                const continueResult = await this.$swal({
                  title: this.$t('F.A.Q.'),
                  html: `<div style="text-align: left;"><p>${answer}</p></div><hr/><p>${this.$t('Would you like to ask another question?')}</p>`,
                  icon: 'info',
                  showCancelButton: true,
                  confirmButtonText: this.$t('Yes, ask again'),
                  cancelButtonText: this.$t('No, thanks'),
                  width: '90%',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-secondary ml-1',
                  },
                  buttonsStyling: false,
                })

                if (continueResult.isConfirmed) {
                  askQuestion() // Recursively ask again
                }
              } catch (e) {
                console.error(e)
                this.$swal(
                  this.$t('Error'),
                  this.$t('Something went wrong. Please try again.'),
                  'error',
                )
              }
            },
          })
        }
      }

      // Start conversation
      askQuestion()
    },
  },
}
</script>

<style>

</style>
